module.exports = __webpack_public_path__ + "static/img/u8.bb1a0f76.png";